<template>
  <div class="plan-card">
    <slot />
  </div>
</template>

<script>
export default {
  name: "PlanCard"
}
</script>

<style lang="scss" scoped>
@use "../../../scss/_variables.scss";

.plan-card {
  background-color: variables.$pure-white;
  border: thin solid variables.$charcoal-tint-20;
  border-radius: 8px;
}
</style>